import axios from 'axios';
import { BASE_URL } from './config';

// 创建axios实例并设置默认配置
const instance = axios.create({
  baseURL: BASE_URL,
  timeout: 5000
});

// 请求拦截器
instance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['token'] = token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 用户注册
export const register = (username, password) => {
  return instance.post('/api/user/register', {
    username,
    password
  });
};

// 用户登录
export const login = (account, password) => {
  return instance.post('/api/user/login', {
    account,
    password
  });
};

// 获取用户信息
export const getUserInfo = (token) => {
  return instance.get('/api/user/index', {
    params: { token }
  });
};

// 上传文件
export function uploadFile(data) {
  return instance({
    url: '/api/common/upload',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data
  })
}

// 更新个人资料
export function updateProfile(data) {
  return instance({
    url: '/api/user/profile',
    method: 'post',
    data: {
      ...data,
      token: localStorage.getItem('token')
    }
  })
}

// 修改密码
export function changePassword(oldpassword, newpassword) {
  return instance({
    url: '/api/user/changepwd',
    method: 'post',
    data: {
      oldpassword,
      newpassword,
      token: localStorage.getItem('token')
    }
  })
}

// 获取打赏记录
export function getRewardRecords(page = 1) {
  return instance({
    url: '/api/video_reward/records',
    method: 'get',
    params: { page }
  });
}

// 获取打赏统计
export function getRewardStatistics() {
  return instance({
    url: '/api/video_reward/statistics',
    method: 'get'
  });
}

// 绑定手机号
export function bindMobile(mobile, captcha) {
  return instance({
    url: '/api/user/bindMobile',
    method: 'post',
    data: { mobile, captcha, token: localStorage.getItem('token') }
  })
}

// 绑定邮箱
export function bindEmail(email, captcha) {
  return instance({
    url: '/api/user/bindEmail',
    method: 'post',
    data: { email, captcha, token: localStorage.getItem('token') }
  })
}

// 发送短信验证码
export function sendSms(mobile, event) {
  return instance({
    url: '/api/sms/send',
    method: 'post',
    data: { mobile, event }
  })
}

// 发送邮箱验证码
export function sendEms(email, event) {
  return instance({
    url: '/api/ems/send',
    method: 'post',
    data: { email, event }
  })
}